import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from "vue";
import devicePresets from "@src/config/devicePresets";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfiguratorModeModal',
  emits: ["apply", "close", "select-custom"],
  setup(__props, { emit }) {



const isModalVisible = ref(true);
const selectedPreset = ref<string>();

const presets: Array<string> = devicePresets.map((preset) => {
  return preset.name;
});

function apply(): void {
  // console.log(devicePresets);
  const index = devicePresets.findIndex((preset) => {
    return preset.name === selectedPreset.value;
  });

  if (index !== undefined) {
    emit(
      "apply",
      devicePresets[index].width,
      devicePresets[index].height,
      devicePresets[index].modules,
    );
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_VSelect = _resolveComponent("VSelect")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isModalVisible.value,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isModalVisible).value = $event)),
    width: "auto",
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode("New device")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_subtitle, null, {
            default: _withCtx(() => [
              _createTextVNode("How would You like to build your new device? ")
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_container, { class: "mt-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                align: "center",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, { size: "x-large" }, {
                        default: _withCtx(() => [
                          _createTextVNode("RANDOM")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_v_col, { cols: "auto" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        size: "x-large",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('select-custom')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("CUSTOM")
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_row, {
                class: "py-4",
                align: "center",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_subtitle, { class: "justify-center" }, {
                    default: _withCtx(() => [
                      _createTextVNode("or from a preset ")
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_row, {
                align: "center",
                justify: "center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_VSelect, {
                        modelValue: selectedPreset.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPreset).value = $event)),
                        class: "ma-3",
                        label: "DEVICE PRESETS",
                        variant: "outlined",
                        items: _unref(presets)
                      }, null, 8 /* PROPS */, ["modelValue", "items"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "secondary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Close")
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                disabled: !selectedPreset.value,
                onClick: apply
              }, {
                default: _withCtx(() => [
                  _createTextVNode("BUILD ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["disabled"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["modelValue"]))
}
}

})